export const handleKeyboardAction = ({ key }, callback) => (key === 'Enter' || key === ' ') && callback();
